import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
//import axios from "axios";
import style from "../style/Login.module.css";
import { FiEye, FiEyeOff, FiMoon, FiSun } from "react-icons/fi";
import { authService } from "../api";

function LoginPage({ onAuthSuccess, theme = "dark", onThemeToggle }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true); // por defecto recordar 30 días
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionExpired = searchParams.get("expired") === "1";


const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  try {
    // 1. Llamamos al servicio (pasamos el objeto que espera la API)
    const res = await authService.login({
      email,
      password,
      rememberMe,
    });

    const newToken = res.data.token;

    // 2. Limpiamos rastro anterior
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");

    // 3. Guardamos según la preferencia del usuario
    if (rememberMe) {
      localStorage.setItem("token", newToken);
    } else {
      sessionStorage.setItem("token", newToken);
    }

    // 4. Éxito: avisamos a App y navegamos
    onAuthSuccess(newToken);
    navigate(searchParams.get("next") || "/");
    
  } catch (err) {
    console.error("Login error:", err);
    // Extraemos SIEMPRE un string (evita el crash de React si el backend o
    // Vercel devuelven un objeto de error como { code, message }).
    const data = err.response?.data;
    const message =
      (typeof data?.error === "string" && data.error) ||
      (typeof data?.message === "string" && data.message) ||
      (typeof data === "string" && data) ||
      "Error al iniciar sesión";
    setError(message);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className={style.container}>
      <div className={style.back}>
        <div className={style.authTopbar}>
          <button
            type="button"
            className={style.themeButton}
            onClick={onThemeToggle}
            aria-label={theme === "dark" ? "Activar tema claro" : "Activar tema oscuro"}
          >
            <FiSun className={style.themeIcon} />
            <span className={style.themeSwitchTrack}>
              <span className={style.themeSwitchThumb} />
            </span>
            <FiMoon className={style.themeIcon} />
          </button>
        </div>
        <div className={style.containerForm}>
          <img src="./imgInicio.webp" alt="imgInicio" />

          <form className={style.formCol} onSubmit={handleSubmit}>
            <p className={style.title}>Iniciar sesión</p>

            {sessionExpired && !error ? (
              <p className={style.infoNote}>
                Tu sesión expiró. Iniciá sesión de nuevo para seguir.
              </p>
            ) : null}

            <div className={style.containerInput}>
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className={style.containerInput}>
              <label>Contraseña</label>

              <div className={style.passwordWrapper}>
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />

                <span
                  className={style.eye}
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </span>
              </div>
            </div>

         

            <button
              type="submit"
              className={loading ? style.btnLoading : style.btn}
              disabled={loading}
            >
              {loading ? <div className={style.spinner} /> : "Iniciar sesión"}
            </button>

            {error && <p className={style.errorText}>{error}</p>}

            <p className={style.link} onClick={() => navigate("/forgot-password")}>
              Olvidé mi contraseña
            </p>

            <p className={style.link} onClick={() => navigate("/register")}>
              ¿No tenés cuenta? Registrate
            </p>
               {/* ✅ CHECKBOX */}
            <label className={style.rememberRow}>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <span>Recordarme por 30 días</span>
            </label>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
